import React, { useEffect } from "react";
import SectionHeader from "../components/SectionHeader";

const TEAM_IMG = "/brand/about-team.jpeg";
const LOGO_FULL = "/brand/logo-full.webp";

export default function AboutPage() {
  useEffect(() => { document.title = "About — Je Ke Pictures"; }, []);
  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32" data-testid="about-page">
      <SectionHeader eyebrow="Our House" title="About Je Ke Pictures" />

      {/* Brand mark */}
      <div className="flex justify-center my-14">
        <div className="bg-white rounded-2xl px-10 py-8 ring-1 ring-white/10 shadow-[0_20px_60px_rgba(0,0,0,0.5)]" data-testid="about-logo">
          <img src={LOGO_FULL} alt="Je Ke Pictures Pvt. Ltd." className="h-20 md:h-28 w-auto object-contain" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
        <div className="md:col-span-7 space-y-6 text-[color:var(--jk-muted)] leading-relaxed">
          <p className="text-lg text-white">
            Je Ke Pictures Pvt. Ltd. is a Bhojpuri-language production house committed to premium production values, storytelling excellence, and cinematic craftsmanship.
          </p>
          <p>
            Founded with a singular vision — to elevate regional cinema through disciplined craft, emotional honesty, and technical rigour — the company invests in stories rooted in the soil, told with the ambition of world cinema.
          </p>
          <p>
            Our debut feature <span className="text-[color:var(--jk-gold)] font-cinzel">Anchara Ke Daag</span> (आंचरा के दाग) marks a new chapter in premium Bhojpuri storytelling — an 8-award-winning drama of family, honour, and a mother's unbreakable love.
          </p>
          <p>
            From script to screen, every project is shaped by an unwavering respect for the audience, for the artists, and for the language of film itself. We believe cinema is heritage — and heritage deserves care.
          </p>
        </div>
        <div className="md:col-span-5">
          <div className="aspect-[4/3] overflow-hidden border border-white/5 rounded-lg">
            <img src={TEAM_IMG} alt="Je Ke Pictures team" loading="lazy" className="w-full h-full object-cover" data-testid="about-photo" />
          </div>
          <div className="text-xs text-[color:var(--jk-muted)] mt-3 text-center tracking-wider">
            The Je Ke Pictures team — celebrating “Anchara Ke Daag”
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="p-8 border border-white/5" data-testid="producer-bio">
          <div className="font-cinzel text-[0.65rem] tracking-[0.4em] text-[color:var(--jk-gold)] uppercase mb-3">The Producer</div>
          <h3 className="font-cinzel font-bold text-2xl mb-4">Kandhan Mudaliyar</h3>
          <p className="text-[color:var(--jk-muted)] leading-relaxed">
            Producer of Je Ke Pictures, leading with a commitment to craft-forward filmmaking and long-term artistic vision.
          </p>
        </div>
        <div className="p-8 border border-white/5" data-testid="director-bio">
          <div className="font-cinzel text-[0.65rem] tracking-[0.4em] text-[color:var(--jk-gold)] uppercase mb-3">Writer &amp; Director</div>
          <h3 className="font-cinzel font-bold text-2xl mb-4">Rambali Gupta</h3>
          <p className="text-[color:var(--jk-muted)] leading-relaxed">
            Writer and director bringing a distinct visual grammar to Bhojpuri storytelling, blending traditional emotional beats with contemporary cinematic technique.
          </p>
        </div>
      </div>
    </div>
  );
}
